// libs
import { styled } from '@nykaa/ui-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const LoginNudgeContainer = styled.div`
  position: relative;
`;

export const LoaderContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.spacing10};
  pointer-events: none;
`;

export const WishlistButton = styled.div`
  width: 32px;
  height: 32px;
  display: flex;

  justify-content: center;
  align-items: center;
`;
